module.exports = __webpack_public_path__ + "img/retail10.bcf2317b.png";